import {
  BFF_ROUTES,
  ResumeConfirmResponseSchema,
  ResumeContinueResponseSchema,
  type ResumeConfirmRequest,
  type ResumeConfirmResponse,
  type ResumeContinueResponse,
} from '@rheora/enrollment-contract';

import { bffPost } from './bff-client';

/**
 * E-CRM04 — the Continue press on `/resume/continue`: the BFF redeems the token
 * the link's GET held and says where to go. `ok: false` is an answer too
 * (`/resume/expired`), not an error.
 */
export async function postResumeContinue(): Promise<ResumeContinueResponse> {
  return bffPost(BFF_ROUTES.resumeContinue, {}, ResumeContinueResponseSchema);
}

/** "Start over instead" on `/resume/continue` — drop the held token. */
export async function postResumeContinueSkip(): Promise<ResumeContinueResponse> {
  return bffPost(BFF_ROUTES.resumeContinueSkip, {}, ResumeContinueResponseSchema);
}

/**
 * E-CRM04 — the phone check for a resume link sent to an UNVERIFIED email.
 * A mismatch is a 200 answer `{ ok: false, attemptsLeft }` (it used to be a 422,
 * which printed a console error in the customer's browser for a typo).
 */
export async function postResumeConfirm(
  request: ResumeConfirmRequest,
): Promise<ResumeConfirmResponse> {
  return bffPost(BFF_ROUTES.resumeConfirm, request, ResumeConfirmResponseSchema);
}

/** "Start over instead" on `/resume/confirm` — discard the held lead. */
export async function postResumeConfirmSkip(): Promise<ResumeConfirmResponse> {
  return bffPost(BFF_ROUTES.resumeConfirmSkip, {}, ResumeConfirmResponseSchema);
}
